import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//import { usePdf } from '@mikecousins/react-pdf';
import Table from 'react-bootstrap/Table';
import { formatMonthYear, sortByDate } from "./../../utils";
import '@progress/kendo-theme-default/dist/all.css';
import { PDFViewer } from '@progress/kendo-react-pdf-viewer';
import Spinner from 'react-bootstrap/Spinner';
import InputGroup from 'react-bootstrap/InputGroup';

import {
    IntlProvider,
    load,
    LocalizationProvider,
    loadMessages,
} from "@progress/kendo-react-intl";
import Skeleton from 'react-loading-skeleton';
import frMessages from "./../tables/fr-FR.json";
loadMessages(frMessages, "fr");

const ReportsAdmin = () => {
    const pdfs = ["https://cdn.filestackcontent.com/wcrjf9qPTCKXV3hMXDwK", "https://owasp.org/www-pdf-archive/GOD17-CORS.pdf", "https://www.entnet.org/wp-content/uploads/2021/04/Instructions-for-Adding-Your-Logo-2.pdf"]
    const [page, setPage] = useState(1);
    const canvasRef = useRef(null);
    const [file, setFile] = useState(pdfs[0]);
    
    let navigate = useNavigate();
    const { usersAdminStore, loginStore, utilsStore, fileStore } = useStores();
    const { getAllUsers, users } = usersAdminStore;
    const { getClients, clients, getProjects, projects, getDevelopers, developers, getMonthsForDev, devMonths } = utilsStore;
    const { getReportFile } = fileStore;
    const { t, i18n } = useTranslation();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const openRandomPdf = () => {
        var min = 0;
        var max = pdfs.length - 1;
        let rand = Math.floor(Math.random() * (max - min + 1)) + min;
        setFile(pdfs[rand]);
        setPage(1)
    }
    const [isClientLoading, setClientLoading] = useState(false);
    const [isProjectLoading, setProjectLoading] = useState(false);
    const [isDevLoading, setDevLoading] = useState(false);
    const [isDateLoading, setDateLoading] = useState(false);


    useEffect(() => {
        setClientLoading(true);
        Promise.all([getClients()]).then(() => setClientLoading(false));
    }, []);

    const [client, setClient] = useState(-1);
    const [project, setProject] = useState(-1);
    const [dev, setDev] = useState(-1);
    const [devMonth, setDevMonth] = useState(-1);
    const [includeDeleted, setIncludeDeleted] = useState(false);


    const onClientChange = (event) => {
        setClient(event.target.value);
        var id = parseInt(event.target.value);
        if (!isNaN(id)) {
            setProjectLoading(true);
            Promise.all([getProjects(id)]).then(() => setProjectLoading(false));
        }

    }

    const onProjectChange = (event) => {
        setProject(event.target.value);
        
        var id = parseInt(event.target.value);
        if (!isNaN(id)) {
            setDevLoading(true);
            Promise.all([getDevelopers(id, includeDeleted)]).then(() => setDevLoading(false));
        }
    }

    const onDevDeleteChange = (event) => {
        setDev(-1);
        setDevMonth(-1);        

        var value = event.target.checked;
        setIncludeDeleted(value);
        
        if (project>-1) {
            setDevLoading(true);
            Promise.all([getDevelopers(project, value)]).then(() => setDevLoading(false));
        }
    }
    const onDevChange = (event) => {
        setDev(event.target.value);
        
        var id = parseInt(event.target.value);
        if (!isNaN(id)) {
            setDateLoading(true);
            Promise.all([getMonthsForDev(project, id)]).then(() => setDateLoading(false));
        }
    }

    const onMonthChange = (event) => {
        setDevMonth(event.target.value);
    }

    useEffect(() => {
        setProject(-1);
    }, [client]);

    useEffect(() => {
        if (project == -1)
            setDev(-1);
    }, [project]);

    useEffect(() => {
        if (dev == -1)
            setDevMonth(-1);
    }, [dev]);

    const [pdfData, setPdfData] = useState(null);

    const getUniqueMonths = () => {
        return [...new Set(devMonths?.map(x => `${x.month}_${x.year}`))]
            ?.map(k => { return { id: k, date: new Date(k.split("_")[1], parseInt(k.split("_")[0]) - 1, 1) } })
            ?.sort((a, b) => a.date.getTime() - b.date.getTime());
        // { return { id: `${x.month}_${x.year}`, date: new Date(x.year, x.month + 1, 1) } }))]?.sort((a, b) => a.date.getTime() - b.date.getTime());
    }
    const canReport = () => client != -1 && project != -1 && dev != -1 && devMonth != -1;

    return (
        <Card>
            <Card.Body>                
                <Stack gap={1}>
                    <Stack direction="horizontal" gap={3}>
                        <Stack direction="vertical" >

                            <b>{t('client')}:</b>
                            <InputGroup className="mb-3">

                                <Form.Select aria-label="Client" onChange={onClientChange} value={client} disabled={clients?.length == 0}>
                                    <option value={-1}>{t("none")}</option>
                                    {clients?.map((x, i) => (
                                        <option key={i} value={x.id}>{x.name}</option>
                                    ))}
                                </Form.Select>
                                {isClientLoading && <InputGroup.Text>
                                    <Spinner animation="border" role="status" size="sm">
                                        <span className="visually-hidden">Loading...</span>
                                    </Spinner>
                                </InputGroup.Text>}

                            </InputGroup>
                        </Stack>

                        <Stack direction="vertical">


                            <b>{t('project')}:</b>
                            <InputGroup className="mb-3">
                                <Form.Select aria-label="Project" onChange={onProjectChange} value={project} disabled={client == -1 || projects?.length == 0}>
                                    <option value={-1}>{t("none")}</option>
                                    {(projects)?.map((x, i) => (
                                        <option key={i} value={x.id}>{x.name}</option>
                                    ))}
                                </Form.Select>
                                {isProjectLoading && <InputGroup.Text>
                                    <Spinner animation="border" role="status" size="sm">
                                        <span className="visually-hidden">Loading...</span>
                                    </Spinner>
                                </InputGroup.Text>}

                            </InputGroup>
                        </Stack>

                        <Stack direction="vertical" >

                            <Stack direction="horizontal" gap={5}>
                                <b>{t('consultant')}:</b> 
                                <Form.Check // prettier-ignore
                                    onChange={onDevDeleteChange}
                                    className="ms-auto"
                                    style={{ margin: 0, minHeight: 0 }}
                                    type="checkbox"
                                    id="includeDeleted"
                                    label={t("includeDeleted")}
                                    value={includeDeleted}
                                />
                            </Stack>
                            
                            <InputGroup className="mb-3">
                                <Form.Select aria-label="Developers" onChange={onDevChange} value={dev} disabled={project == -1 || developers?.length == 0}>
                                    <option value={-1}>{t("none")}</option>
                                    {developers?.map((x, i) => (
                                        <option key={i} value={x.id}>{x.name} {x.surname}</option>
                                    ))}
                                </Form.Select>
                                {isDevLoading && <InputGroup.Text>
                                    <Spinner animation="border" role="status" size="sm">
                                        <span className="visually-hidden">Loading...</span>
                                    </Spinner>
                                </InputGroup.Text>}

                            </InputGroup>
                        </Stack>

                        <Stack direction="vertical" >

                            <b>{t('date')}:</b>
                            <InputGroup className="mb-3">
                                <Form.Select aria-label="Months" onChange={onMonthChange} value={devMonth} disabled={dev == -1 || getUniqueMonths()?.length == 0}>
                                    <option value={-1}>{t("none")}</option>
                                    {getUniqueMonths()?.map((x, i) => (
                                        <option key={i} value={x.id}>{formatMonthYear(x.date)}</option>
                                    ))}
                                </Form.Select>
                                {isDateLoading && <InputGroup.Text>
                                    <Spinner animation="border" role="status" size="sm">
                                        <span className="visually-hidden">Loading...</span>
                                    </Spinner>
                                </InputGroup.Text>}
                            </InputGroup>
                        </Stack>
                        <Stack direction="vertical" >
                            
                            <Button className="btn btn-secondary my-auto" disabled={!canReport()} onClick={() => {

                                //navigate(`/users/${user.id}`);
                                getReportFile(client, project, dev, devMonth).then((result) => {     

                                    //console.log(decodeURIComponent(result?.filenameUTF));

                                    var fileReader = new FileReader();
                                    fileReader.onload = function (event) {                                        
                                        setPdfData({
                                            //id: invoice.id,
                                            filename: result?.utf_filename ?? result.filename,
                                            data: event.target.result
                                        });
                                    };
                                    fileReader.readAsArrayBuffer(result.bytes);
                                });
                            }}>{t('generateReport')}</Button>
                        </Stack>
                    </Stack>

                    {pdfData && <LocalizationProvider language={i18n.language}><PDFViewer
                        saveFileName={pdfData?.filename}
                        arrayBuffer={pdfData?.data} tools={[
                            "pager",
                            "spacer",
                            "zoomInOut",
                            "zoom",
                            "selection",
                            "spacer",
                            "search",/*,
                            "open",*/
                            "download"/*,
                            "print",*/]}
                    /></LocalizationProvider>}


                </Stack>
            </Card.Body>

        </Card>

    );
};

export default observer(ReportsAdmin);
